/**
 * The three interest fields every loan-creating screen has to send, derived in
 * one place from whatever the کارمزد modal handed back.
 *
 * **`interest_rate` is a FRACTION on the wire.** The backend repays
 * `amount × (1 + interest_rate)` (`Loan.total_repayment_amount`), so «۱ درصد»
 * has to leave the client as `0.01`, not `1`.
 *
 * Four screens built this payload by hand and two of them passed the picker's
 * number straight through, which multiplied every fee by a hundred. Accepting
 * a loan request with «۱ درصد» granted a **100 percent** loan: 30,000,000
 * تومان repaid as 3 × 20,000,000 (loan 36058, 1405/05/28). The «مبلغ ثابت» tab
 * was unaffected — it never went through `interest_rate`.
 *
 * Derive it here rather than at each call site; a fifth screen must not get a
 * fifth chance to drop the division.
 */
export interface ILoanInterestFields {
    interest_type: string
    interest_rate: number
    fixed_interest_amount: number
}

export const FEE_TYPE_PERCENTAGE = 'percentage'

export const loanInterestFields = (
    feeType: string | undefined,
    feeValue: number | undefined | null
): ILoanInterestFields => {
    const value = Number(feeValue ?? 0) || 0

    if (feeType === FEE_TYPE_PERCENTAGE) {
        return {
            interest_type: FEE_TYPE_PERCENTAGE,
            interest_rate: value / 100,
            fixed_interest_amount: 0,
        }
    }

    return {
        interest_type: feeType ?? 'fixed',
        interest_rate: 0,
        fixed_interest_amount: value,
    }
}
